import { render, staticRenderFns } from "./QuestionnairesTitle.vue?vue&type=template&id=3506ff10&scoped=true&"
import script from "./QuestionnairesTitle.vue?vue&type=script&lang=js&"
export * from "./QuestionnairesTitle.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnairesTitle.vue?vue&type=style&index=0&id=3506ff10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3506ff10",
  null
  
)

export default component.exports